import { IPaginationConfig } from "./types";

export const DEFAULT_PAGINATION_CONFIG = {
    itemsPerPage: 50,
    pageSizeOptions: [10, 20, 50, 100]
}
export const DEFAULT_ITEMS_PAGINATION_CONFIG: IPaginationConfig = {
        total: 0,
        currentPage: 1,
        itemsPerPage: 50,
        numPages: 0,
        viewOffset: 0,
        viewEnd: 50
} 
export const DEFAULT_PAGINATION_CONFIG_LAZY = {
    scrollThrottleTime: 200,
    scrollOffsetPercent: 10,
    onScrolled: async () => await Promise.resolve()
}
export const DEFAULT_PAGE_TITLE = 'Sync.com';

export const VIRTUAL_SCROLL_HEIGHT_SETTINGS = {
    mobile: { listView: 300, gridView: 315 },
    desktop: { listView: 235, gridView: 274 }
}

export const DEFAULT_CONTROL_DEBOUNCE_TIME_MS = 300;
export const DEFAULT_SCROLL_THROTTLE_TIME_MS = 500;